import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import InputFormField from 'src/registry/components/forms/InputFormField';
import SelectFormField from 'src/registry/components/forms/SelectFormField';
import { Form } from 'src/registry/ui/Form';
import { membershipUsersMessages } from 'src/features/membershipCloudUsers/utils/messages';
import { MEMBERSHIP_USER_ACCESS_LEVEL } from 'src/features/membership/types';
import { MEMBERSHIP_USER_ACCESS_LEVEL_TRANSLATIONS } from 'src/features/membershipCloudUsers/utils/constants';
import { entityMessages } from 'src/features/entity/utils/messages';
import { MembershipCloudUserFormSchemaValues } from 'src/features/membershipCloudUsers/utils/formSchema';

type MembershipCloudUserFormProps = {
    form: UseFormReturn<MembershipCloudUserFormSchemaValues>;
    onSubmit: (values: MembershipCloudUserFormSchemaValues) => void;
};

function MembershipCloudUserForm({ onSubmit, form }: MembershipCloudUserFormProps) {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<MembershipCloudUserFormSchemaValues>
                form={form}
                name="email"
                type="email"
                label={formatMessage(entityMessages.email)}
            />
            <SelectFormField<MembershipCloudUserFormSchemaValues>
                form={form}
                required
                name="access_level"
                label={formatMessage(membershipUsersMessages.accessLevel)}
                options={Object.values(MEMBERSHIP_USER_ACCESS_LEVEL)}
                optionTranslationMap={MEMBERSHIP_USER_ACCESS_LEVEL_TRANSLATIONS}
            />
        </Form>
    );
}

export default MembershipCloudUserForm;
